import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import $ from 'jquery';
var ComponentExample = /*#__PURE__*/function () {
  function ComponentExample() {
    _classCallCheck(this, ComponentExample);
    this.selector = '.component-example';
    this.$el = $(this.selector);
    if (!this.$el.length) return false;
    this.bindEvents();
  }
  _createClass(ComponentExample, [{
    key: "bindEvents",
    value: function bindEvents() {
      // this.$el.on('click', this.onClick.bind(this));
    }

    // onClick() {

    // }
  }]);
  return ComponentExample;
}();
new ComponentExample();